<template>
  <div v-if="isVisible" class="popup-mask">
    <div class="popup-dialog" role="dialog" aria-modal="true" aria-labelledby="popup-title">
      <div class="popup-header">
        <div id="popup-title" class="popup-title">用户须知</div>
        <button class="popup-close" aria-label="关闭" @click="handleCancel">
            <img class="popup-close-icon" src="/assets/~/media/images/icon/close-grey.png" alt="关闭">
        </button>
      </div>
      <div class="popup-content">
        <p class="intro">本功能是基于起亚官网实时数据提供的官网信息AI查询智能服务，请注意：</p>
        <ul class="bullet-list">
          <li>AI生成内容可能存在局限性或偏差</li>
          <li>车辆配置/召回公告等信息请以官方说明或及具体页面为准</li>
          <li>活动和政策等具体信息经销商最终解释为准</li>
          <li>为了获得更顺畅的浏览体验，请确保您的网络连接稳定</li>
        </ul>
        <p class="confirm">点击「同意」即视为您理解上述声明，起亚将全力为您提供支持！</p>
      </div>
      <div class="popup-footer">
        <button class="btn btn-ghost" @click="handleCancel"  code-stm="event, PAGEURL, 用户须知-取消">取消</button>
        <button class="btn btn-primary" @click="handleAgree" code-stm="event, PAGEURL, 用户须知-同意">同意</button>
      </div>
    </div>
  </div>
</template>

<script>
import { isPortraitFun } from '@/utils/utils';
const STORAGE_KEY = 'kia_ai_notice_accepted_at';
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export default {
  name: 'Popup',
  props: {
    title: { type: String, default: '用户须知' },
    forceShow: { type: Boolean, default: false },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    if (this.forceShow) {
      this.isVisible = true;
      return;
    }
    try {
      const ts = localStorage.getItem(STORAGE_KEY);
      const last = ts ? Number(ts) : 0;
      const now = Date.now();
      if (!last || now - last > ONE_DAY_MS) {
        this.isVisible = true;
      }
    } catch (e) {
      this.isVisible = true;
    }
  },
  methods: {
    handleAgree() {
      try {
        localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {}
      this.isVisible = false;
      this.$emit('agree');
    },
    handleCancel() {
      this.isVisible = false;
      this.$emit('cancel');
      // 返回上一级页面
      // 判断是否为移动设备

      if (isPortraitFun()) { 
        // 对于移动设备，直接跳转到起亚首页
        window.location.href = 'https://www.kia.cn';
      } else {
        // 统一所有设备类型都跳转到起亚官网首页
        window.location.href = 'https://www.kia.cn';
        // 对于PC设备，保持原有的返回上一页逻辑
        // if (typeof window !== 'undefined' && window.history && window.history.length > 0) {
        //   window.history.back();
        // }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* 尺寸：PC 使用 vh，MOB 使用 vw；比例 617x317 */
.popup-dialog {
  background: #fff;
  border-radius: calc(12 / 1080 * 100vh);
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);

  @media (min-width: 768px) {
    width: calc(617 / 1080 * 100vh);
    height: calc(340 / 1080 * 100vh);
  }
  @media (max-width: 767px) {
    width: calc(340 / 375 * 100vw);//calc(300 / 375 * 100vw);
    height: calc(340 / 375 * 100vw);
  }

  display: flex;
  flex-direction: column;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(16 / 1080 * 100vh) calc(20 / 1080 * 100vh);
  background-color: rgba(248, 248, 248, 1);
}

.popup-title {
  font-size: calc(18 / 1080 * 100vh);
  color: rgba(0, 0, 0, 1);
  font-family: 'FZLanTingHeiS-B-GB'; 
  
  /* 手机端 */
  @media (max-width: 767px) { 
    font-size: calc(20 / 1080 * 100vh);
    font-family: 'FZLanTingHeiS-DB-GB';
    
    padding-left: calc(6 / 375 * 100vw);
    padding-right: calc(6 / 375 * 100vw);
  }
  
}

.popup-close {
  width: calc(32 / 1080 * 100vh);
  height: calc(32 / 1080 * 100vh);
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}
.popup-close-icon {
  width: calc(20 / 1080 * 100vh);
  height: calc(20 / 1080 * 100vh);
  object-fit: contain;
}

.popup-content {
  flex: 1;
  padding: calc(16 / 1080 * 100vh) calc(20 / 1080 * 100vh);
  color: rgba(0, 0, 0, 0.85);
  overflow-y: auto;

  /* 手机端 */
     /* 手机端 */
  @media (max-width: 767px) {  
    padding-left: calc(22 / 375 * 100vw);
    padding-right: calc(22 / 375 * 100vw);
  }
}

.intro {
  margin: 0 0 calc(8 / 1080 * 100vh);
  font-size: calc(16 / 1080 * 100vh);
  font-family: 'FZLanTingHeiS-R-GB';
   /* 手机端 */
  @media (max-width: 767px) { 
    font-size: calc(17 / 1080 * 100vh);
  }
}

.bullet-list {
  margin: 0 0 calc(8 / 1080 * 100vh);
  padding-left: calc(18 / 1080 * 100vh);
  li {
    list-style: disc;
    line-height: 1.6;
    font-size: calc(16 / 1080 * 100vh);
    //font-weight: bold;
    font-family: 'FZLanTingHeiS-DB-GB';
     @media (max-width: 767px) { 
      font-family: 'FZLanTingHeiS-R-GB';
      font-size: calc(17 / 1080 * 100vh); 
      line-height: 1.7;
    }
  }
}

.confirm {
  margin: 0;
  font-size: calc(14 / 1080 * 100vh);
  font-family: 'FZLanTingHeiS-R-GB';
  color: rgba(0, 0, 0, 0.5);
  @media (max-width: 767px) { 
    font-size: calc(13 / 1080 * 100vh);
  }
}

.popup-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: calc(8 / 1080 * 100vh);
  padding: 0 calc(20 / 1080 * 100vh) calc(25 / 1080 * 100vh) calc(20 / 1080 * 100vh);
//   border-top: 1px solid rgba(0, 0, 0, 0.06);


@media (max-width: 767px) {
    justify-content: center;
}



}

/* 按钮 140x46；PC 使用 vh，MOB 使用 vw */
.btn {
  border-radius: calc(6 / 1080 * 100vh);
  cursor: pointer;
  border: 1px solid #000;
  font-size: calc(16 / 1080 * 100vh);
  font-family: 'FZLanTingHeiS-R-GB';
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media (min-width: 768px) {
    width: calc(140 / 1080 * 100vh);
    height: calc(46 / 1080 * 100vh);
  }
  @media (max-width: 767px) {
    width: calc(140 / 375 * 100vw);
    height: calc(46 / 375 * 100vw);
    font-size: calc(17 / 1080 * 100vh);
  }
}

.btn-primary {
  background: #000;
  color: #fff;
}
.btn-primary:hover {
  background: #fff;
  color: #000;
}

.btn-ghost {
  background: #fff;
  color: #000;
}
.btn-ghost:hover {
  background: #000;
  color: #fff;
}
</style>
